import { render, staticRenderFns } from "./Requirements.vue?vue&type=template&id=da979282&scoped=true&"
import script from "./Requirements.vue?vue&type=script&lang=js&"
export * from "./Requirements.vue?vue&type=script&lang=js&"
import style0 from "./Requirements.vue?vue&type=style&index=0&id=da979282&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da979282",
  null
  
)

export default component.exports